import { useRecordContext, useTranslate } from "react-admin";
import Chip from '@material-ui/core/Chip';

const ChipTranslateField = (props) => {
    const translate = useTranslate();
    const record = useRecordContext();
    const { source } = props;
    const value = record?.[source];
    return (
        <span className="chipItem">
            {record && <Chip key={record.id} label={translate(`resources.${source}.${value}`)} />}
        </span>
    )
};

export default ChipTranslateField;